export const CREATE_CONTACT_ENQUIRY_REQUEST = "CREATE_CONTACT_ENQUIRY_REQUEST"
export const CREATE_CONTACT_ENQUIRY_SUCCESS = "CREATE_CONTACT_ENQUIRY_SUCCESS"
export const CREATE_CONTACT_ENQUIRY_FAILURE = "CREATE_CONTACT_ENQUIRY_FAILURE"
export const SET_CONTACT_ENQUIRY_REQUEST = "SET_CONTACT_ENQUIRY_REQUEST"